import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const CustomerListRowFieldsFragmentDoc = gql`
  fragment CustomerListRowFields on OrgCustomerRow {
    gross_profit_in_micros_total
    last_invoice_date
    line_items_total
    margin_percentage
    order_count
    restaurant_account_id
    restaurant_id
    restaurant_name
    revenue_in_micros_total
    sales_rep_id
    sales_rep_name
    supplier_id
  }
`;
export const PricingCustomerListDataDocument = gql`
  query PricingCustomerListData {
    getCustomerListDataForBusinessOrganization {
      customers {
        ...CustomerListRowFields
      }
    }
  }
  ${CustomerListRowFieldsFragmentDoc}
`;
export function usePricingCustomerListDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PricingCustomerListDataQuery,
    Types.PricingCustomerListDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PricingCustomerListDataQuery,
    Types.PricingCustomerListDataQueryVariables
  >(PricingCustomerListDataDocument, options);
}
export function usePricingCustomerListDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PricingCustomerListDataQuery,
    Types.PricingCustomerListDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PricingCustomerListDataQuery,
    Types.PricingCustomerListDataQueryVariables
  >(PricingCustomerListDataDocument, options);
}
export type PricingCustomerListDataQueryHookResult = ReturnType<
  typeof usePricingCustomerListDataQuery
>;
export type PricingCustomerListDataLazyQueryHookResult = ReturnType<
  typeof usePricingCustomerListDataLazyQuery
>;
export type PricingCustomerListDataQueryResult = Apollo.QueryResult<
  Types.PricingCustomerListDataQuery,
  Types.PricingCustomerListDataQueryVariables
>;

/**
 * Wrapped version of useGeneratedPricingCustomerListDataQuery using Pepper's useWrappedQuery
 */
export function useGeneratedPricingCustomerListDataQuery(
  options?: Apollo.QueryHookOptions<
    Types.PricingCustomerListDataQuery,
    Types.PricingCustomerListDataQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.PricingCustomerListDataQuery,
    Types.PricingCustomerListDataQueryVariables
  >(PricingCustomerListDataDocument, options);
}

/**
 * Wrapped version of useGeneratedPricingCustomerListDataLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedPricingCustomerListDataLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.PricingCustomerListDataQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.PricingCustomerListDataQuery,
    Types.PricingCustomerListDataQueryVariables
  >(PricingCustomerListDataDocument, lazyOptions);
}
